import { render, staticRenderFns } from "./autosuggestion.vue?vue&type=template&id=14bbd778&scoped=true&"
import script from "./autosuggestion.vue?vue&type=script&lang=js&"
export * from "./autosuggestion.vue?vue&type=script&lang=js&"
import style0 from "./autosuggestion.vue?vue&type=style&index=0&id=14bbd778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bbd778",
  null
  
)

export default component.exports